import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

/**
 * Shared "are you sure?" delete confirmation. Pass already-translated strings so
 * this stays a plain function (usable outside React components).
 */
export default function confirmDelete({ title, message, confirmText, cancelText, onConfirm }) {
  MySwal.fire({
    title: <strong>{title}</strong>,
    html: <i>{message}</i>,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
  }).then((res) => {
    if (res.isConfirmed) onConfirm?.();
  });
}
